export const LOCAL_STORAGE_AUTH_KEY = 'auth-react';
export const LOCAL_STORAGE_COUNT_DOWN_TIME = 'count-down-time';
